export default __webpack_public_path__ + "static/media/web-summer.bf2d091c.png";